(function() {
  'use strict';

  angular
    .module('service.contentPlayer', ['factories.serviceHelper'])
    .factory('ContentPlayerService', ContentPlayerService);

  ContentPlayerService.$inject = ['$http', 'ServiceHelper', '$window'];

  function ContentPlayerService($http, ServiceHelper, $window) {
    var url = {
      reuseState: 'https://:host/:ipad/mm/cs/trainee/course/:courseId/cModule/:cModuleId/reuse-state',
      base: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/course/:courseId/:action',
      module: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/:action',
      frames: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/course/:courseId/frame/:action',
      frame: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/course/:courseId/frame/:frameId/:action'
    };
    var keys = ['ipad', 'cModuleId', 'courseId', 'action', 'frameId'];
    var serviceStatus = [];
    var cModuleId = null;
    var courseId = null;

    var service = {
      start: start,
      nextSlide: nextSlide,
      writeFrameDurations: writeFrameDurations,
      updateFrameProgress: updateFrameProgress,
      sendEmailToTrainer: sendEmailToTrainer,
      sendPreview: sendPreview,
      throwTestError: throwTestError,
      getCompletionInfo: getCompletionInfo,
      reuseState: reuseState,
      serviceStatus: serviceStatus,
      isPreview: false
    };

    return service;

    function start(params, resultCb, errorCb) {
      cModuleId = params.cModuleId;
      courseId = params.courseId;

      var action = $window.mfConfig.isIpad ? 'StartIpad' : 'StartWeb';
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: cModuleId,
        courseId: courseId,
        action: action
      });
      return ServiceHelper.checkCanCallService(function() {
        var config = { params: {} };
        if (params.frameId) {
          config.params.frameId = params.frameId;
        }
        return respond($http.get(createUrl(url.base, urlParams), config),
          resultCb, errorCb);
      });
    }

    function reuseState(resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: cModuleId,
        courseId: courseId
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.reuseState, urlParams)),
          resultCb, errorCb);
      });
    }

    function writeFrameDurations(cModuleId, durations, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: cModuleId,
        courseId: courseId,
        action: 'durations'
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.frames, urlParams), {
          durations: durations
        }), resultCb, errorCb);
      });
    }

    function updateFrameProgress(cModuleId, frameId, progressSeconds, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: cModuleId,
        courseId: courseId,
        frameId: frameId,
        action: 'progress'
      });
      var frameProgress = {
        progressSeconds: progressSeconds
      };
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.frame, urlParams), frameProgress),
          resultCb, errorCb);
      });
    }

    function sendEmailToTrainer(emailInfo, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: emailInfo.cModuleId,
        courseId: emailInfo.courseId,
        action: 'SendEmailToTrainer'
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.base, urlParams), emailInfo),
          resultCb, errorCb);
      });
    }

    function sendPreview(emailInfo, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: emailInfo.cModuleId,
        courseId: emailInfo.courseId,
        action: 'SendPreview'
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.module, urlParams), emailInfo),
          resultCb, errorCb);
      });
    }

    function throwTestError(resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        action: 'testThrownError'
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.base, urlParams)),
          resultCb, errorCb);
      });
    }

    function getCompletionInfo(cModuleId, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: cModuleId,
        courseId: courseId,
        action: 'completion'
      });
      return ServiceHelper.checkCanCallService(function() {
        return respond($http.get(createUrl(url.base, urlParams)),
          resultCb, errorCb);
      });
    }

    function nextSlide(params, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: params.cModuleId,
        courseId: params.courseId,
        action: 'nextSlide'
      });
      return ServiceHelper.checkCanCallService(function() {
        var serviceProcessId = _.uniqueId('nextSlide_');
        serviceStatus.push(serviceProcessId);
        return respondNext($http.post(createUrl(url.base, urlParams), params),
          serviceResponder(resultCb, serviceProcessId),
          serviceResponder(ServiceHelper.errorHandler(errorCb), serviceProcessId));
      });
    }

    function respondNext(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return errorCb(response);
      });
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb)(response);
      });
    }

    function serviceResponder(cb, serviceProcessId) {
      cb = cb || angular.noop;
      return function(result) {
        serviceStatus.splice(serviceStatus.indexOf(serviceProcessId), 1);
        cb(result);
      }
    }

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key];
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }
  }
})();
